import { Card, Typography, Modal, Form, Input } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import FbPixelLogin from '../fb-pixel-login'
import {
    createMetaAdsIntegration,
    deleteMetaAdsIntegration,
    getMetaAdsIntegration,
    updateMetaAdsIntegration
} from '../../services/meta-ads-integration'

import { toast } from 'sonner'
export function MetaPixelIntegration({ icon, label, assistantID }) {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState()
    const [buttonLoading, setButtonLoading] = useState(false)

    // Future proofing: configuration modal if needed
    const [configOpen, setConfigOpen] = useState(false)
    const [form] = Form.useForm()

    useEffect(() => {
        setLoading(true)
        getMetaAdsIntegration({ assistantID })
            .then(({ data }) => {
                if (data.length === 0) return
                setData(data[0])
            })
            .catch((error) => {
                console.log(error)
                toast.error('Erro ao buscar integração com a Meta.')
            })
            .finally(() => {
                setLoading(false)
            })
    }, [assistantID])

    const install = useCallback(
        (values) => {
            setButtonLoading(true)
            createMetaAdsIntegration({
                assistantID: parseInt(assistantID),
                token: values.accessToken,
            })
                .then((res) => {
                    setData(res.data)
                    toast.success('Conectado com sucesso!')
                })
                .catch((error) => {
                    console.log(error)
                    toast.error('Erro ao instalar integração.')
                })
                .finally(() => {
                    setButtonLoading(false)
                })
        },
        [assistantID]
    )

    const uninstall = useCallback(() => {
        setButtonLoading(true)
        deleteMetaAdsIntegration(data.id)
            .then(() => {
                setData(undefined)
                toast.success('Removido com sucesso!')
            })
            .catch((error) => {
                console.log(error)
                toast.error('Erro ao remover integração.')
            })
            .finally(() => {
                setButtonLoading(false)
            })
    }, [data])

    return (
        <>
            <Card
                loading={loading}
                title={
                    <Typography.Title level={5} ellipsis={{ tooltip: label }}>
                        {icon} {label}
                    </Typography.Title>
                }
                extra={
                    <FbPixelLogin
                        data={data}
                        loading={loading}
                        buttonLoading={buttonLoading}
                        install={install}
                        uninstall={uninstall}
                    />
                }
                actions={
                    // Optional: Settings button if we have more config later
                    undefined
                }
            >
                <Typography>
                    {data ?
                        `Integrado com sucesso.` :
                        'Conecte sua conta do Meta'
                    }
                </Typography>
            </Card>
        </>
    )
}
